import React from 'react';
import Popover from '../Popover';
import { Wrap, ConfirmBtn } from './Confirm.stc';

function Confirm({ children, text, onConfirm }) {
    return (
        <Popover
            placement="top"
            content={(_, close) => (
                <Wrap>
                    {text}
                    <ConfirmBtn.Group gap={5} style={{ textAlign: 'right' }}>
                        <ConfirmBtn onClick={close} btnType="alt">
                            No
                        </ConfirmBtn>
                        <ConfirmBtn onClick={onConfirm}>Yes</ConfirmBtn>
                    </ConfirmBtn.Group>
                </Wrap>
            )}
        >
            {children}
        </Popover>
    );
}

export default Confirm;
